import Vue from 'vue'
import numberWithCommas from './numberWithCommas'

const filters = [
  numberWithCommas,
]

export default function () {
  filters.forEach(filter => Vue.filter(filter.name, filter.handler))
}
